import React, { useEffect } from 'react';
import moment from 'moment';
import { Icon } from 'semantic-ui-react';
import { Waypoint } from 'react-waypoint';
import IconPill from 'Assets/images/pages/web-chat/pill.svg';
import { number } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getListPrescriptionOrders } from 'Redux/modules/webChat/actions';
import { FILE_API_URL } from 'Constants/env';
import useActiveClinicTab from 'Containers/Teleconsult/hooks/useActiveClinicTab';

import EmptyList from '../EmptyList';

import styles from './PrescriptionOrder.less';

const PER_PAGE = 30;

const PrescriptionOrder = ({ byPatientId, forPatientId }) => {
  const dispatch = useDispatch();
  const {
    prescriptions,
    status: { listPrescriptions: loading },
    meta: { pagination },
  } = useSelector(state => state.webChat.prescription);
  const { activeClinicTab } = useActiveClinicTab();

  const { limit, offset, total } = pagination ?? {};

  const handleWaypointEnter = () => {
    if (loading !== 0) {
      const isLoadMore = true;
      dispatch(
        getListPrescriptionOrders(
          {
            limit,
            offset: offset + PER_PAGE,
            status: 1,
            byPatientId,
            forPatientId,
            clinicId: activeClinicTab,
          },
          isLoadMore,
        ),
      );
    }
  };

  useEffect(() => {
    dispatch(
      getListPrescriptionOrders({
        limit: PER_PAGE,
        offset: 0,
        status: 1,
        byPatientId,
        forPatientId,
        clinicId: activeClinicTab,
      }),
    );
  }, [byPatientId, dispatch, forPatientId]);

  return (
    <div>
      <div className={styles.listItem}>
        {prescriptions?.map(item => {
          return (
            <a
              href={`${FILE_API_URL}/files/${item.pdfFileId}`}
              className={styles.item}
              key={item.id}
              target="_blank"
              rel="noreferrer">
              <div className={styles.medicalType}>
                <img src={IconPill} alt="mc" />
                Prescription
              </div>
              <div className={styles.date}>{moment(item.createdAt).format('MMM DD,YYYY')}</div>
            </a>
          );
        })}
      </div>
      {offset + limit < total && (
        <Waypoint onEnter={handleWaypointEnter}>
          <div className="text-center">
            <Icon name="spinner" loading size="big" />
          </div>
        </Waypoint>
      )}

      {total === 0 && <EmptyList text="No prescriptions yet" />}
    </div>
  );
};

PrescriptionOrder.propTypes = {
  byPatientId: number.isRequired,
  forPatientId: number.isRequired,
};

export default PrescriptionOrder;
